import { useState } from 'react';
import styled from 'styled-components';
import { Avatar } from 'antd';
import fileSaver from 'file-saver';
import LightBox from 'react-image-lightbox';
import mime from 'mime';
import { FileTwoTone } from '@ant-design/icons';
import { HSMSIcon } from './HSMSIcon';

export const HSMSImageBlockWrapper = styled.div`
  display: inline-block;
  margin-right: 10px;
  border: 1px dashed #d9d9d9;
  padding: 4px;
  border-radius: 4px;
  background-color: #fafafa;

  .image-actions {
    text-align: center;
    margin-top: 6px;
    margin-bottom: -4px;

    .hsms-icon {
      color: #5555;
      -webkit-transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      cursor: pointer;

      &:hover {
        color: #575757;
      }
    }
  }

  .spaced-image-action {
    margin-right: 5px;
  }
`;

export interface HSMSImageBlockProps {
  urls: string[];
}

export const HSMSImageBlocks = ({ urls }: HSMSImageBlockProps) => {
  const [preview, setPreview] = useState<{ photoIndex: number; previewImage: string; previewVisible: boolean }>({
    photoIndex: 0,
    previewImage: '',
    previewVisible: false,
  });

  return (
    <>
      {urls.map((url) => {
        let fileName = url.split('/').pop();
        if (fileName) {
          [fileName] = fileName.split('#')[0].split('?');
        }

        const fileType = () => {
          const type = process.browser ? mime.getType(fileName || 'file') : 'file';
          if (type) {
            return type.split('/')[0];
          }
          return 'corrupted';
        };

        return (
          <HSMSImageBlockWrapper key={url}>
            {fileType() === 'image' ? (
              <Avatar shape="square" size={102} src={url} />
            ) : (
              <FileTwoTone height={2} style={{ margin: 39, fontSize: 25 }} />
            )}
            <div className="image-actions">
              <HSMSIcon
                name="visibility"
                className="spaced-image-action"
                onClick={() => {
                  if (fileType() === 'image') {
                    setPreview({
                      ...preview,
                      previewImage: url,
                      previewVisible: true,
                    });
                  } else {
                    window.open(url);
                  }
                }}
              />
              <HSMSIcon
                name="cloud_download"
                onClick={() => {
                  fileSaver.saveAs(url, fileName);
                }}
              />
            </div>

            {preview.previewVisible && (
              <LightBox
                mainSrc={preview.previewImage}
                onCloseRequest={() => setPreview({ ...preview, previewVisible: false })}
              />
            )}
          </HSMSImageBlockWrapper>
        );
      })}
    </>
  );
};
